import { Outlet, createFileRoute, redirect } from '@tanstack/react-router'

/**
 * A pathless layout route that guards everything nested under it.
 *
 * Any route file inside src/routes/_authed/ is automatically protected: if
 * there is no session, the user is sent to /login with a `redirect` pointing
 * back here so they land where they meant to go.
 *
 * This reads `context.auth` SYNCHRONOUSLY, which is safe only because main.tsx
 * resolves the stored session before the first render.
 */
export const Route = createFileRoute('/_authed')({
  beforeLoad: ({ context, location }) => {
    if (!context.auth.session) {
      throw redirect({ to: '/login', search: { redirect: location.href } })
    }
  },
  component: () => <Outlet />,
})
